import React, { useState, useEffect } from "react";
import SpeciesCode from "../../components/SpeciesCode";
import Kept from "../../components/Kept";
import Discarded from "../../components/Discarded";

export default function CatchForm(props) {
  const [isNC, setIsNC] = useState(false);

  useEffect(() => {
    setIsNC(props.speciesCode === "NC" ? true : false);
  }, [props]);

  return (
    <div className="margAll10">
      <SpeciesCode
        reportType={props.reportType}
        tripType={props.tripType}
        changeHandler={props.speciesCodeChange}
        speciescode={props.speciesCode}
        handleGearPreferenceChange={props.handleGearPreferenceChange}
      />
      {!isNC && (
        <>
          <Kept
            kept={props.kept}
            handleInputChange={props.handleChange}
            uom={props.uom}
          />
          <Discarded
            discarded={props.discarded}
            handleInputChange={props.handleChange}
            uom={props.uom}
          />
        </>
      )}
    </div>
  );
}
